let nextDraftOrderId = 1

export function createDraftOrder ({ rowId, fileId = null } = {}) {
  return {
    rowId: rowId || `draft-order-${nextDraftOrderId++}`,
    fileId,
    zoneVersion: 0,
    fulfillment_order_reference: '',
    skus: '',
    quantity: '',
    pickup_point: '',
    errors: {},
    cities: [],
    zones: [],
    status: 0,
    customer: {
      full_name: '',
      phone: '',
      address: {
        line_1: '',
        zone: '',
        city: '',
        governorate: ''
      }
    },
    secondary_phone: '',
    type: '',
    number_of_packages: '',
    cash_amount: '',
    is_customer_allowed_to_open_packages: false,
    fragile: false,
    loadRow: false,
    order_notes: '',
    merchant_order_reference: '',
    is_counter_dropoff: false,
    line_2: '',
    declared_value: '',
    discount_code: '',
    dba: '',
    shipping_fees: '',
    product_sku: '',
    requested_quantity: ''
  }
}
